export const eventConstants = {
  EVENT_LOAD: '[Event] Load',
  EVENT_LOAD_SUCCESS: '[Event] Load success',
  EVENT_LOAD_FAILURE: '[Event] Load failure',
  EVENT_RESET: '[Event] Reset'
}
